import React from "react";
import {IMAGES, KButton, KBUTTON_SIZE, KBUTTON_VARIANT, KSpace} from "@kopjra/uikit";
import {Translate} from "react-redux-i18n";
import {Col, Row} from "react-bootstrap";

export interface Props {
    emptyText?: string | JSX.Element;
    createText?: string | JSX.Element;
    onCreateSomething: () => void | Promise<void>;
    creating?: boolean;
}

export const EmptyCreate: React.FC<Props> = ({emptyText, onCreateSomething, creating, createText}) => {
    return (
        <>
            <KSpace spaces={3}/>
            <img src={IMAGES["web-trust"].still.large.dark} height={165} alt={"Web trust"}/>
            <KSpace/>
            <h4>{emptyText ? emptyText : <Translate value="generic.emptyCollection"/>}</h4>
            <KSpace spaces={2}/>
            <Row>
                <Col md={4} lg={3}>
                    <KButton
                        text={creating ? <i className="fal fa-spin fa-spinner-third"/> : createText || (<Translate value="generic.create"/>)}
                        disabled={creating}
                        variant={KBUTTON_VARIANT.primary}
                        size={KBUTTON_SIZE.nm}
                        onClick={() => onCreateSomething()}
                        fill={true}
                    />
                </Col>
            </Row>
            {/*<KSpace spaces={2}/>*/}
            {/*<h4><a className="link" href={`mailto:info@kopjra.com?subject=${I18n.t("home.contactSubject")}&body=${I18n.t("home.contactBody")}`} target="_blank" rel="noopener noreferrer"><Translate value="home.contactus"/></a></h4>*/}
        </>
    )
}
